import React from "react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import TableComponent from "./Table";
import { columns } from "../utils/applicationPageLogic";
import { formatBogotaDate } from "../utils/dateUtils";
// import AssociatedDocuments from "./AssociatedDocuments";

const AppQuestionnaireRightSide = ({
  assignappQuestionnaireId,
  loading,
  /* documents, */
  maxDate,
  rows,
  setOpenFinishAppModal,
}) => {
  return (
    <Box
      className="application-questionnaires-panel"
      sx={{
        width: "100%",
        minWidth: 0,
      }}
    >
      {assignappQuestionnaireId ? null : loading ? (
        // <AssociatedDocuments documents={documents} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 5,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Stack
            direction={{
              xs: "column",
              sm: "row",
            }}
            alignItems={{
              xs: "flex-start",
              sm: "center",
            }}
            justifyContent="space-between"
            spacing={0.75}
            sx={{
              mb: {
                xs: 2,
                sm: 3,
              },
            }}
          >
            <Typography
              component="span"
              color="text.secondary"
              sx={{
                fontWeight: 600,
                fontSize: {
                  xs: "0.9rem",
                  sm: "1rem",
                },
              }}
            >
              Fecha máxima de presentación:
            </Typography>

            <Typography
              component="span"
              color="text.primary"
              sx={{
                fontWeight: 600,
                fontSize: {
                  xs: "0.95rem",
                  sm: "1rem",
                },
              }}
            >
              {maxDate ? formatBogotaDate(maxDate) : "—"}
            </Typography>
          </Stack>

          <TableComponent columns={columns} rows={rows} prioritizeButtons={true} noData={rows?.length === 0} />

          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: {
                xs: "stretch",
                sm: "flex-start",
              },
            }}
          >
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={() => setOpenFinishAppModal(true)}
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                },
                minWidth: {
                  sm: "120px",
                },
              }}
            >
              Terminar
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AppQuestionnaireRightSide;
